(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-constants/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-constants/assets/javascripts/constants.js');

'use strict';

const CONSTANTS = {
  LOCATION_TYPES: {
    NONE: 'NONE',
    HOME: 'HOME',
    CURRENT: 'CURRENT',
    OTHER: 'OTHER'
  },
  PAYOUT_KEYS: {
    LATEST_DRAW: 'latestDraw',
    THIS_YEAR: 'thisYear',
    SINCE_LAUNCH: 'sinceLaunch',
    SPECIFIC_DRAWS: 'specifiedDraws'
  },
  PRICE_PER_WEEK: 40,
  FIRST_ZOOM_LEVEL: 11,
  PLACE_PIN_ZOOM_LEVEL: 15,
  DRAWS: {
    NUMBER_OF_WEEKS: 4,
    DRAWS_PER_WEEK: 3
  },
  DRAW_STATE: {
    OPEN: 2,
    REG_CLOSED: 3,
    CANCEL_CLOSED: 4,
    FINALIZED: 20
  },
  CORRECTION_STEP: {
    START: 0,
    TOPWIN: 1,
    PLACE: 2,
    DISTANCE: 3,
    RESULT: 4
  },
  CORRECTION_TRIGGER_TYPE: {
    CLICK: 1,
    AUTOMATED: 2
  },
  RESULT_INTERVALS: {
    THIRTY_DAYS: '30-dagar',
    SIX_MONTHS: '6-manader',
    ONE_YEAR: '1-ar'
  },
  GEO_SEARCH_TYPES: {
    PLACE: 'place',
    ADDRESS: 'address'
  },
  CHARITY_STATUS: {
    ACTIVE: 1,
    INACTIVE: 2,
    HIDDEN: 4
  },
  NO_CHARITY_TEXT: {
    title: 'Hoppsan!',
    description: "H\xE4r vill vi presentera v\xE4lg\xF6renhetsorganisationerna vi samarbetar med,\n            men kan f\xF6r tillf\xE4llet inte visa dem. Du kan \xE4nd\xE5 spela Lyckoplatsen som vanligt och innan f\xF6rsta dragningens spelstopp\n            komplettera spelet med ett val av organisation om du vill, som d\xE5 f\xE5r 10% av insatsen,\n            utan att det kostar n\xE5got extra eller p\xE5verkar din vinstchans."
  },
  GEO_ACCURACY_THRESHOLD: 60,
  CONFETTI_COLORS: [[32, 115, 229], [22, 255, 171], [255, 93, 57], [221, 236, 255], [213, 255, 240]],
  INTERVAL_PATHS: {
    30: '30-dagar',
    183: '6-manader',
    365: '1-ar'
  }
};
function getIntervalKeyByValue(value) {
  return Object.keys(CONSTANTS.INTERVAL_PATHS).find(k => CONSTANTS.INTERVAL_PATHS[k] === value);
}
if (svs.isServer) {
  module.exports = {
    CONSTANTS,
    getIntervalKeyByValue
  };
} else {
  Object.assign(svs.lyckoplatsen.components.shared_constants, {
    CONSTANTS,
    getIntervalKeyByValue
  });
}

 })(window);